export class UrlHelper {
  static join(url: string, url2: string): string {
    if (!url.endsWith("/")) {
      url += "/";
    }

    return url + url2;
  }
}